import { useTranslation } from "react-i18next";
import { FormRow } from "../../../../../style/form";
import { UserConfigCollaboratorFormModel } from "./useUserCollaboratorConfigForm";
import { SelectPair } from "../../../../../types/common.types";
import { Select } from "antd";
import styled from "styled-components";

const SelectAppraiserWrapper = styled.div`
  flex: 1;

  .select-studio-label {
    text-transform: uppercase;
    font-size: 0.9em;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
`;

const SelectStyled = styled(Select)`
  width: 100%;
  margin-bottom: 2em;
`;

interface IUserCollaboratorConfigFormProps {
  model: UserConfigCollaboratorFormModel;
  studioOptions: SelectPair[];
  onChange: (value: any, field: string) => void;
}

const UserCollaboratorConfigForm = (
  props: IUserCollaboratorConfigFormProps
) => {
  const { model, studioOptions, onChange } = props;

  const { t } = useTranslation();

  const handleSelectStudio = (index: string) => {
    const iId = parseInt(index);
    const _studio = studioOptions[iId];
    if (_studio) {
      onChange(_studio.value, "studioId");
    }
  };

  const selectedValue = studioOptions.find(
    (_) => _.value === model.studioId?.toString()
  );

  const handleFilterSearchStudio = (input: string, option: any) =>
    option.children[0].toLowerCase().indexOf(input.toLowerCase()) > -1;

  return (
    <FormRow>
      <SelectAppraiserWrapper>
        <div className="select-studio-label" data-testid="select-studio-label">
          {t("user-collaborator-config-form-studio-label")}
        </div>

        <SelectStyled
          data-testid="select-studio-select"
          onChange={(index) => handleSelectStudio(index as string)}
          value={selectedValue}
          filterOption={handleFilterSearchStudio}
          showSearch
        >
          {studioOptions.map((item, i) => (
            <Select.Option key={i}>
              {item.label}
            </Select.Option>
          ))}
        </SelectStyled>
      </SelectAppraiserWrapper>
    </FormRow>
  );
};
export default UserCollaboratorConfigForm;
